module.exports = __webpack_public_path__ + "static/img/1.7d0c24a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/1.png
// module id = BaPB
// module chunks = 1